export default function AdminReloadOverlay({ visible, message = "Atualizando..." }) {
  if (!visible) return null;

  return (
    <div className="admin-reload-overlay">
      <div className="admin-reload-overlay-content">
        <span className="admin-reload-spinner" aria-hidden="true" />
        <p className="admin-reload-message">{message}</p>
      </div>
    </div>
  );
}
